import { useEffect, useState } from 'react';

export function useMounted(props) {
  const { requiredValues = [] } = props;

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(requiredValues.every((value) => !!value));
  }, [...requiredValues]);

  return { mounted };
}

export default useMounted;
